import HttpTmed from '../http/tmed';

export const getHealthData = (cpf) => HttpTmed.get(`/health-data/${cpf}`);

export const updateHealthData = (cpf, payload) => HttpTmed.put(`/health-data/${cpf}`, payload);
